import script from "./CreateUserProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUserProfile.vue?vue&type=script&setup=true&lang=js"

import "./CreateUserProfile.vue?vue&type=style&index=0&id=0e8d7d20&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e8d7d20"]])

export default __exports__